import styled from 'styled-components'

export const Container = styled.section`
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 200px 0 62px;
  width: 100%;

  @media (max-width: 950px) {
    padding-top: 62px;
  }
`

export const Content = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 32px;
  justify-content: space-between;
  max-width: 1240px;
  width: 100%;

  @media (max-width: 950px) {
    gap: 62px;
    grid-template-columns: 1fr;
    place-items: center;
  }
`
